export default __webpack_public_path__ + "static/media/shuffle.bcfb61c7.svg";